var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.36353,
    y: 9.45447,
    width: 10.8,
    height: 10.8,
    fill: "#FBE9EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5715 3.45288C24.6395 3.45288 27.3635 6.30888 27.3635 10.5569V20.3621C27.3635 24.5981 24.6395 27.4529 20.5715 27.4529H10.1675C6.09953 27.4529 3.36353 24.5981 3.36353 20.3621V10.5569C3.36353 6.30888 6.09953 3.45288 10.1675 3.45288H20.5715ZM18.9755 11.8181C18.5675 11.4089 17.9075 11.4089 17.4875 11.8181L15.3635 13.9529L13.2275 11.8181C12.8075 11.4089 12.1475 11.4089 11.7395 11.8181C11.3315 12.2261 11.3315 12.8981 11.7395 13.3049L13.8755 15.4421L11.7395 17.5661C11.3315 17.9861 11.3315 18.6461 11.7395 19.0529C11.9435 19.2569 12.2195 19.3661 12.4835 19.3661C12.7595 19.3661 13.0235 19.2569 13.2275 19.0529L15.3635 16.9301L17.4995 19.0529C17.7035 19.2701 17.9675 19.3661 18.2315 19.3661C18.5075 19.3661 18.7715 19.2569 18.9755 19.0529C19.3835 18.6461 19.3835 17.9861 18.9755 17.5781L16.8395 15.4421L18.9755 13.3049C19.3835 12.8981 19.3835 12.2261 18.9755 11.8181Z",
    fill: "#E24C82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close_button.cbdbeffbdb502815949b9ce62c8c8ce1.svg";
export { ForwardRef as ReactComponent };